export default "<div>\n  <div (click)=\"handleClick($event)\">\n    <span>Manage</span>\n  </div>\n</div>\n";